import { Provider, ThemePrepared } from '@fluentui/react-northstar';
import { FabricTeamsThemeCustomizer } from '@smb/fabric-teams-theme';
import * as React from 'react';
import { initFabricIcons } from '../../fabric-icons/init-fabric-icons';
import { getThemeNameGivenStardustTheme } from './TeamsCustomizationUtilities';

export class TeamsThemeForFabricUI extends React.Component {
  public render(): JSX.Element {
    initFabricIcons();
    return <Provider.Consumer render={this._renderGivenTheme} />;
  }

  private _renderGivenTheme = (theme: ThemePrepared) => {
    const themeName = getThemeNameGivenStardustTheme(theme);
    return (
      <FabricTeamsThemeCustomizer themeName={themeName}>
        {this.props.children}
      </FabricTeamsThemeCustomizer>
    );
  };
}
